<template>
  <div id="page_news">
    <div class="banner">
      <img src="../assets/img/news_banner.jpg" alt="" class="bg">
      <div class="textbox">
        <h2 class="wow fadeInDown">More About The Acoustics Industry And What's Happening To Brotex</h2>
      </div>
    </div>
    <div id="part1">
      <router-link :to="{path:'./NewsInfo',query:{id:item.id}}" class="item" v-for="(item,index) in newsList" :key="index">
        <img :src="`${$https}${item.articleImg}`" alt="">
        <div class="right">
          <div class="textbox">
            <div class="timebox">
              <img src="../assets/img/news_timeicon.png" alt="">
              <span>{{item.timelist}}</span>
            </div>
            <h3>{{item.name}}</h3>
            <p>{{item.desc}}</p>
            <div class="mainBtn1 hbutton_isi">LEARN MORE</div>
          </div>
        </div>
      </router-link>
    </div>
    <el-pagination class="pagniation"
       layout="prev, pager, next"
       @current-change="handleCurrentChange"
       :page-size="pageSize"
       :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import * as $request from "../api/index";
export default {
  name: "News",
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | News',
  },
  components:{
  },
  data(){
    return{
      newsList:[],
      pageSize:9,//每页几个
      pageIndex:1,//第几页
      total:0,//总数
    }
  },
  methods:{
    handleCurrentChange(val) {
      this.pageIndex=val
      this.getNews(this.pageIndex,this.pageSize)
    },
    getNews(pageIndex,pageSize){
      $request.getnews(pageIndex,pageSize).then(res=>{
        this.newsList=res.datas
        this.total=res.totalCount
        this.newsList.forEach(val => {
          val.timelist=this.$date(val.releaseDate)
        })
        console.log(this.newsList)
      })

    },
  },
  created() {
    this.$emit('getnav',6)
    this.getNews(this.pageIndex,this.pageSize)
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<style lang="less" scoped>
#page_news{
  .banner{position: relative;z-index: 1;padding: 0.7rem 3%;text-align: center;overflow: hidden;
    .bg{position: absolute;bottom: 0;right: 0;z-index: -1;}
    .textbox{
      h2{color: white;width: 100%;margin: 0 auto;}
    }
    .crumb{font: 20px Poppins-SemiBold;margin-top: 60px;
      a{color: white;
        &:not(:last-child):after{content: '>';margin: 0 20px;}
        &:last-child{border-bottom: 1px solid white;}
      }
    }
  }
  #part1{
    .item{position: relative;margin-bottom: .2rem;display: block;
      img{width: 100%;height: 2.2rem;object-fit: cover;}
      .right{width: 90%;margin: -25% auto 0;z-index: 3;position: relative;
        .timebox{display: flex;justify-content: flex-start;align-items: center;margin-bottom: .1rem;
          img{width: .2rem;height: .2rem;margin-right: .1rem;}
          span{font: .12rem Poppins-Regular;color: @main-c5;}
        }
        .textbox{background: #F5F5F5;height: 100%;padding: .15rem;
          h3{margin-bottom: .1rem;}
          //p{margin: 20px 0 30px;}
        }
      }
      &:last-child{margin-bottom: 0;}
      //&:nth-child(2n){text-align: right;
      //  .right{right: unset;left: 280px;text-align: left;
      //    .timebox{justify-content: flex-start;}
      //  }
      //}
    }
  }
  .pagniation{margin-bottom: .3rem;}
}
</style>